"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSwitchChain = exports.useAddChain = void 0;
var react_1 = require("react");
var bignumber_1 = require("@ethersproject/bignumber");
var bytes_1 = require("@ethersproject/bytes");
var useWeb3_1 = require("./useWeb3");
var network_1 = __importDefault(require("../connectors/network"));
var other_1 = require("../connectors/other");
var error_1 = require("../utils/error");
var useAddChain = function () {
    var library = (0, useWeb3_1.useActiveWeb3)().library;
    return (0, react_1.useCallback)(function (chainId, info) { return __awaiter(void 0, void 0, void 0, function () {
        var formattedChainId, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!((_a = library === null || library === void 0 ? void 0 : library.provider) === null || _a === void 0 ? void 0 : _a.request))
                        return [2 /*return*/];
                    formattedChainId = (0, bytes_1.hexStripZeros)(bignumber_1.BigNumber.from(chainId).toHexString());
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, library.provider.request({
                            method: 'wallet_addEthereumChain',
                            params: [
                                {
                                    chainId: formattedChainId,
                                    chainName: info.label,
                                    rpcUrls: info.rpcUrls,
                                    nativeCurrency: info.nativeCurrency,
                                    blockExplorerUrls: [info.explorer]
                                }
                            ]
                        })];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    console.error('error add eth network: ', chainId, info, error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [library]);
};
exports.useAddChain = useAddChain;
var useSwitchChain = function () {
    var _a = (0, useWeb3_1.useActiveWeb3)(), connector = _a.connector, library = _a.library;
    var addChain = (0, exports.useAddChain)();
    return (0, react_1.useCallback)(function (chainId, info) { return __awaiter(void 0, void 0, void 0, function () {
        var switchChain;
        var _a;
        return __generator(this, function (_b) {
            switchChain = function () { return __awaiter(void 0, void 0, void 0, function () {
                var formattedChainId, error_3;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!((_a = library === null || library === void 0 ? void 0 : library.provider) === null || _a === void 0 ? void 0 : _a.request))
                                return [2 /*return*/];
                            formattedChainId = (0, bytes_1.hexStripZeros)(bignumber_1.BigNumber.from(chainId).toHexString());
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 8]);
                            return [4 /*yield*/, library.provider.request({
                                    method: 'wallet_switchEthereumChain',
                                    params: [{ chainId: formattedChainId }]
                                })];
                        case 2:
                            _b.sent();
                            return [3 /*break*/, 8];
                        case 3:
                            error_3 = _b.sent();
                            if (!(error_3.code === 4902 && chainId !== undefined)) return [3 /*break*/, 6];
                            // metamask (only known implementer) automatically switches after a network is added
                            // the second call is done here because that behavior is not a part of the spec and cannot be relied upon in the future
                            // metamask's behavior when switching to the current network is just to return null (a no-op)
                            return [4 /*yield*/, addChain(chainId, info)];
                        case 4:
                            // metamask (only known implementer) automatically switches after a network is added
                            // the second call is done here because that behavior is not a part of the spec and cannot be relied upon in the future
                            // metamask's behavior when switching to the current network is just to return null (a no-op)
                            _b.sent();
                            return [4 /*yield*/, switchChain()];
                        case 5:
                            _b.sent();
                            return [3 /*break*/, 7];
                        case 6:
                            console.error('error switch eth network: ', chainId, error_3);
                            _b.label = 7;
                        case 7: return [3 /*break*/, 8];
                        case 8: return [2 /*return*/];
                    }
                });
            }); };
            if (connector instanceof network_1.default) {
                connector.switch(chainId);
            }
            else if (connector instanceof other_1.InjectedConnector && ((_a = library === null || library === void 0 ? void 0 : library.provider) === null || _a === void 0 ? void 0 : _a.request)) {
                switchChain();
            }
            else {
                throw new error_1.WalletSwitchChainError();
            }
            return [2 /*return*/];
        });
    }); }, [connector, library, addChain]);
};
exports.useSwitchChain = useSwitchChain;
